import { render, staticRenderFns } from "./important.vue?vue&type=template&id=34ca4e43&scoped=true"
import script from "./important.vue?vue&type=script&lang=js"
export * from "./important.vue?vue&type=script&lang=js"
import style0 from "./important.vue?vue&type=style&index=0&id=34ca4e43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ca4e43",
  null
  
)

export default component.exports